<template>
  <q-page class="q-pa-md" v-if="isReady">

    <div class="text-h6">
      Big query settings
    </div>
    <q-form @submit="saveProperties">

      <q-input label="Big query project id" v-model="properties.projectId"/>

      <q-separator/>
      <q-btn type="submit" label="Save" color="primary" class="q-mt-md"/>
    </q-form>

  </q-page>
</template>

<script>

import {integrationsMixin} from "@/pages/workspace/integrations/integrationsMixin";

export default {
  components: {},
  mixins: [integrationsMixin],
  name: "BigQueryIntegrationSettings",
  data: () => ({
    placement: {},
  }),

  computed: {

    /**
     * Return integration name
     */
    integration: () => ({name: "big-query", type: "database"}),
  }
}

</script>
